import React from "react"
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import {logout} from "../../state/app/actions"
import {colors} from "../../utils/styles"

const titleBarStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 64,
  padding: "0 20px",
  background: colors.white,
  color: colors.mocText,
  borderBottom: "1px solid " + colors.mocBorders,
}

const leftStyle = {
  display: "flex",
  alignItems: "center",
  height: "100%"
}

const baseTitleStyle = {
  fontSize: 16,
  fontWeight: 700,
}

const rightStyle = {
  display: "flex",
  alignItems: "center"
}

const logoutButtonStyle = {
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6
}

export class DigitalTitleBar extends React.Component {

  constructor(props) {
    super(props)
    this.handleLogout = this.handleLogout.bind(this)
  }

  handleLogout() {
    const {actions} = this.props
    if (actions && actions.logout) {
      actions.logout()
    }
  }

  render() {
    return (
        <div className="titleBar" style={titleBarStyle}>
          <div style={leftStyle}>
            <img
                alt="logo"
                src="images/oocl/logo.svg"
                style={{height: 30, width: 83, marginRight: 32}}
            />
            <span style={baseTitleStyle}>Real Time Release</span>
          </div>

          <div style={rightStyle}>
            <div style={logoutButtonStyle} onClick={this.handleLogout}>
              <img
                  alt="logout"
                  src="images/logout-black.svg"
                  style={{height: 20}}
              />
            </div>
          </div>
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAppInitialized: state.app.isAppInitialized
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({logout}, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DigitalTitleBar)